import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Flex } from "../../../components/Flex";
import { Text } from "../../../components/Text";

const Container = styled(Flex)`
  justify-content: center;
  min-height: 100%;
`;

export const NotificationsUpdatesTab: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Text color="darkerSub">
        {t("header.bell.drawer.articles_news.description")}
      </Text>
    </Container>
  );
};
